import { Component, Input } from '@angular/core';

@Component({
    selector: 'cz-letzte-aenderung',
    templateUrl: 'letzte-aenderung.component.html',
    standalone: false
})

export class LetzteAenderungComponent {
    constructor() { }

    @Input() aenderungsDatum:Date;
    @Input() aenderungsNutzer:string;

}
